import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BurstModeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"burst_mode"}/>
}
